module.exports = __webpack_public_path__ + "static/Alex-b40d609446dab8ec75ca37bea6d86bc4.png";